import { Component } from '@angular/core';

@Component({
  selector: 'insol-outline-back-button',
  templateUrl: './outline-back-button.component.html',
})
export class OutlineBackButtonComponent {
  goBack(): void {
    history.back();
  }
}
